(() => {
  function init(root) {
    if (!root || root.dataset.lfInitialized) return;
    root.dataset.lfInitialized = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const gallery = root.querySelector('[data-lf-gallery]');
    const mainImage = gallery?.querySelector('.lf-main-image');
    const zoomLink = root.querySelector('[data-lf-zoom]');
    const zoomDialog = root.querySelector('[data-lf-zoom-dialog]');
    const zoomImage = root.querySelector('[data-lf-zoom-image]');
    gallery?.addEventListener('click', event => {
      const thumb = event.target.closest('[data-lf-thumb]');
      if (!thumb || !mainImage) return;
      gallery.querySelectorAll('[data-lf-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      mainImage.removeAttribute('srcset');
      mainImage.src = thumb.dataset.src;
      mainImage.alt = thumb.dataset.alt;
      zoomLink.href = thumb.dataset.src;
      zoomImage.src = thumb.dataset.src;
      zoomImage.alt = thumb.dataset.alt;
      root.querySelector('[data-lf-caption]').textContent = thumb.dataset.caption;
    });
    zoomLink?.addEventListener('click', event => {
      if (!zoomDialog?.showModal || event.metaKey || event.ctrlKey) return;
      event.preventDefault();
      zoomImage.src = mainImage.currentSrc || mainImage.src;
      zoomImage.alt = mainImage.alt;
      zoomDialog.showModal();
    });
    root.querySelector('[data-lf-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
    zoomDialog?.addEventListener('click', event => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
    zoomDialog?.addEventListener('close', () => zoomLink.focus({ preventScroll: true }));
    const tabs = [...root.querySelectorAll('[data-lf-use]')];
    const activate = button => {
      const id = button.dataset.lfUse;
      tabs.forEach(tab => {
        const active = tab === button;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      root.querySelectorAll('[data-lf-use-panel]').forEach(panel => panel.hidden = panel.dataset.lfUsePanel !== id);
      root.querySelectorAll('[data-lf-scene]').forEach(scene => scene.hidden = scene.dataset.lfScene !== id);
      const caption = button.cloneNode(true);
      caption.querySelectorAll('span').forEach(span => span.remove());
      root.querySelector('[data-lf-scene-label]').textContent = caption.textContent.trim();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next]);
        tabs[next].focus();
      });
    });
    const form = root.querySelector('.lf-purchase');
    const quantity = form?.querySelector('[name="quantity"]');
    const minus = form?.querySelector('[data-lf-minus]');
    const updateQuantity = delta => {
      const value = Number(quantity.value) || 1;
      quantity.value = String(Math.max(1, value + delta));
      minus.disabled = Number(quantity.value) <= 1;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    };
    minus?.addEventListener('click', () => updateQuantity(-1));
    form?.querySelector('[data-lf-plus]')?.addEventListener('click', () => updateQuantity(1));
    quantity?.addEventListener('change', () => {
      if (quantity.validity.valid) minus.disabled = Number(quantity.value) <= 1;
    });
    if (minus) minus.disabled = Number(quantity.value) <= 1;
    const buttons = [...root.querySelectorAll('[data-lf-submit]')];
    const message = root.querySelector('[data-lf-message]');
    let adding = false;
    let available = !buttons[0]?.disabled;
    const setButtons = () => buttons.forEach(button => {
      button.disabled = adding || !available;
      button.querySelector('[data-lf-button-label]').textContent = adding ? root.dataset.adding : available ? root.dataset.add : root.dataset.sold;
    });
    root.querySelector('[data-lf-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      available = option.dataset.available === 'true';
      root.querySelectorAll('[data-lf-price]').forEach(price => price.textContent = option.dataset.price);
      setButtons();
    });
    form?.addEventListener('submit', async event => {
      if (!window.VoyageCart?.add) return;
      event.preventDefault();
      if (adding || !available || !form.reportValidity()) return;
      const values = new FormData(form);
      const count = Number(values.get('quantity'));
      if (!Number.isSafeInteger(count) || count < 1) return;
      adding = true;
      message.hidden = true;
      setButtons();
      try {
        const success = await window.VoyageCart.add([{ id: Number(values.get('id')), quantity: count }]);
        if (!success) throw new Error(root.dataset.error);
      } catch (error) {
        message.textContent = error.message || root.dataset.error;
        message.hidden = false;
      } finally {
        adding = false;
        setButtons();
      }
    });
    const sticky = root.querySelector('[data-lf-sticky]');
    if ('IntersectionObserver' in window && form) {
      const purchaseObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      purchaseObserver.observe(form);
      if (!reduceMotion.matches && !window.Shopify?.designMode) {
        root.classList.add('lf-ready');
        const revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('lf-pending');
            revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px 60px 0px', threshold: 0.01 });
        root.querySelectorAll('[data-lf-reveal]').forEach(element => {
          if (element.getBoundingClientRect().top < window.innerHeight) return;
          element.classList.add('lf-pending');
          revealObserver.observe(element);
        });
        reduceMotion.addEventListener('change', () => {
          if (reduceMotion.matches) {
            root.querySelectorAll('.lf-pending').forEach(element => element.classList.remove('lf-pending'));
            revealObserver.disconnect();
          }
        });
      }
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#lf-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
    });
  }
  const boot = () => document.querySelectorAll('[data-lf-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
